module.exports = __webpack_public_path__ + "static/img/job.076878b1.png";